module.exports = __webpack_public_path__ + "img/12.6eef8d69.jpg";